import { render, staticRenderFns } from "./InspectionRecordDetail.vue?vue&type=template&id=53e08838&scoped=true"
import script from "./InspectionRecordDetail.vue?vue&type=script&lang=js"
export * from "./InspectionRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./InspectionRecordDetail.vue?vue&type=style&index=0&id=53e08838&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e08838",
  null
  
)

export default component.exports